<template>
  <div class="app-container">
    <!--查询条件 客户清零记录2.0-->
    <div class="formBox margbot" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="95px"
        size="mini"
      >
        <div class="formItemBox">
          <el-form-item label="一级货主:" style="margin-top:7px;">
            <el-select v-model="searchFrom.primaryCustomerTaxId" clearable filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in customerData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:" style="margin-top:7px;">
            <el-select v-model="searchFrom.customerTaxId" clearable filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in customerData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:" style="margin-top:7px;">
            <el-select v-model="searchFrom.productType" @change="productTypeChange" clearable placeholder="请选择" filterable >
              <el-option
                v-for="(item, index) in productTypeData"
                :key="index"
                :label="item.productTypeName"
                :value="item.productType"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" style="margin-top:7px;">
            <el-select v-model="searchFrom.steelMillName" @change="steelMillNameChange" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in steelMillNameData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" style="margin-top:7px;">
            <el-select v-model="searchFrom.specification" @change="specificationChange" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in specificationData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="searchFrom.model" @change='modelChange' clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in modelData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="margin-left: 10px;">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="003P01pB001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="003P01pB002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportClick" btnCode="003P01pB003" v-if="btnFlg[2]">导出</el-button>
          </el-form-item>
          <span>总吨数：<span style="color: red">{{allWeight}}</span>吨</span>
        </div>
      </el-form>
    </div>
    <!--  表格 v-loading='tabLoading'-->
    <div class="table" :style="{ height: h }" >
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
        class="tableComent"
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ownerCustomerName" label="货权方" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.allWeight == null || scope.row.allWeight == ''"></span>
            <span v-else>{{Number(scope.row.allWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="120">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.weight == null || scope.row.weight == ''"></span>
            <span v-else>{{Number(scope.row.weight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" align="center" width="120">
           <template slot-scope="scope"><div>
            <span v-if="scope.row.poundWeight == null || scope.row.poundWeight == ''"></span>
            <span v-else>{{Number(scope.row.poundWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="操作人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="操作时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.createTime!= '' || scope.row.createTime != undefined || scope.row.createTime != null">{{scope.row.createTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 40,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  getCustomerClearListZy, // 列表
  getCustomerClearWeightNumber // 总重量总件数
} from '@/api/wms-stock.js'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '003P01pB001',
        '003P01pB002',
        '003P01pB003'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        instockDateStart: '',
        instockDateStartEnd: '',
        model: ''
      },

      pageNo: 1,
      pageSize: 20,
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      tableList: [],
      tabLoading: false,
      allWeight: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/customerClear')
    this.getSeatchData()
    this.getCustomerClearWeightNumber()
    this.getRelationCustomer()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.searchClick()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 下拉框级联
    // getVirtualBalingList () {
    //   getVirtualBalingList({
    //   }).then(res => {
    //     this.productTypeData = []
    //     var obj = {}
    //     for (var i = 0; i < res.length; i++) {
    //       if (!obj[res[i].productTypeName]) {
    //         this.productTypeData.push(res[i])
    //         obj[res[i].productTypeName] = true
    //       }
    //     }
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 总重量
    getCustomerClearWeightNumber () {
      getCustomerClearWeightNumber({ pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchFrom })
        .then(res => {
          console.log(res)
          this.allWeight = res.totalAllWeight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getCustomerClearListZy({ pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchFrom })
        .then((res) => {
          console.log(res)
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData()
      this.getCustomerClearWeightNumber()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20
      }
      this.goodsName = ''
      this.placeOfOrigin = ''
      this.specificationVal = ''
      this.modelVal = ''
      this.getSeatchData()
      this.getCustomerClearWeightNumber()

      this.getVirtualBalingList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.pageSize = val
      this.getSeatchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageNo = val
      this.getSeatchData()
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportCustomerClearList',
        this.searchFrom,
        '客户亏涨记录信息表'
      )
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
/deep/.inpBox .el-input__inner {
  width: 170px;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 5px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.addstyle{
  margin-left: 94%;
}
</style>
